<template>
    <div class="site-side">
      <div id="side-title"><a href="/site"><h1>DAP<div>studio</div></h1></a></div>

      <div class="vmenu">
         <div class="link first top" style="margin:60px 0 4px 0;">ABOUT US</div>
         <router-link to="/inside/profilo/studio" class="_page-team">profile</router-link>
         <router-link to="/inside/profilo/team" class="_page-team">team</router-link>
         <router-link to="/inside/profilo/clienti" class="_page-team">clients</router-link>
         <router-link to="/inside/profilo/premi" class="_page-premi">awards</router-link>
         <router-link to="/inside/profilo/mostre" class="_page-mostre">exhibitions</router-link>
         <router-link to="/inside/profilo/pubblicazioni" class="_page-pubblicazioni">publications</router-link>
         <router-link to="/inside/profilo/eventi" class="_page-eventi">events</router-link>
         <!-- <router-link to="/inside/contatti" class="_page-contatti">contatti</router-link> -->

         <div class="link first top">PROJECTS</div>
         <!-- <router-link to="/inside/progetto/p7" class="first top">PROGETTI</router-link> -->
         <!-- <router-link to="/progetti" class="first top">PROGETTI</router-link> -->

         <router-link to="/progetti" class="_page-selezione">selected</router-link>

         <el-popover ref="temiPop" placement="left" width="140" trigger="hover" v-model="temiPopV">
            <router-link to="/tema/1/interiors" v-on:click.native="temiPopV = false">interiors</router-link>
            <router-link to="/tema/2/graftings" v-on:click.native="temiPopV = false">graftings</router-link>
            <router-link to="/tema/3/reuse" v-on:click.native="temiPopV = false">reuse</router-link>
            <router-link to="/tema/4/relational spaces" v-on:click.native="temiPopV = false">relational spaces</router-link>
            <router-link to="/tema/5/texture" v-on:click.native="temiPopV = false">texture</router-link>
            <router-link to="/tema/6/sustainability" v-on:click.native="temiPopV = false">sustainability</router-link>
            <router-link to="/tema/7/transformation" v-on:click.native="temiPopV = false">transformation</router-link>
         </el-popover>

         <div v-popover:temiPop class="vmenupop" style="width:90px;margin:0 auto;">topics</div>
         <div v-if="$route.params.tipologia!=''" style="font-size:1.3rem;color:#999999;">{{$route.params.tema}}</div>


         <el-popover ref="tipologiePop" placement="left" width="140" trigger="hover" offset="0" v-model="tipologiePopV">
            <router-link to="/tipologia/1/urban spaces and landscape" v-on:click.native="tipologiePopV = false">urban spaces and landscape</router-link>
            <router-link to="/tipologia/2/public buildings" v-on:click.native="tipologiePopV = false">public buildings</router-link>
            <router-link to="/tipologia/3/offices and commercial spaces" v-on:click.native="tipologiePopV = false">offices and commercial spaces</router-link>
            <router-link to="/tipologia/4/housing" v-on:click.native="tipologiePopV = false">housing</router-link>
            <router-link to="/tipologia/5/cultural projects" v-on:click.native="tipologiePopV = false">cultural projects</router-link>
         </el-popover>

         <div v-popover:tipologiePop class="vmenupop" style="width:90px;margin:0 auto;">types</div>
         <div v-if="$route.params.tipologia!=''" style="font-size:1.3rem;color:#999999;">{{$route.params.tipologia}}</div>
      </div>

      <div class="nav-bottom yo-align-center" style="">
         <div class="nav-newsletter">
            <a href="https://d9x0i.emailsp.com/frontend/forms/Subscription.aspx?idList=4&idForm=65&guid=D741F501-C6A8-4BD4-8FFA-6510561937E7" target="_blank">
               <img src="/site/images/newsletter-iscrizione.png" alt="Sign up Newsletter" width="32" /><br />
               <span class="link first top"><strong>SIGN UP FOR OUR NEWSLETTER</strong></span>
            </a><br /><br />
            <router-link to="/inside/profilo/newsletter-archivio" style="color: #666;">newsletter archive</router-link>
         </div>
         <div class="nav-lang">
            <a class="current" href="/site">it</a>
            <router-link to="/">en</router-link>
            <a href="/site/inside/coming/coming">fr</a>
         </div>

         <router-link to="/inside/contatti/contatti" class="first _page-contatti" style="margin:4px 0 8px 0;display:block;">contacts</router-link>
         <router-link to="/inside/contatti/note_legali" class="first _page-contatti" style="margin:4px 0 8px 0;display:block;">legal notes</router-link>

         <div class="nav-social">
            <a target="_blank" href="https://twitter.com/dap_studio"><img src="../assets/twitter.svg" alt="Twitter icon"></a>
            <a target="_blank" href="https://www.facebook.com/pages/DAPstudio-elena-sacco-paolo-danelli/160426864008613"><img src="../assets/facebook.svg" alt="Facebook icon"></a>
            <a target="_blank" href="https://www.instagram.com/paolo_danelli"><img src="../assets/instagram.svg" alt="Instagram icon"></a>
         </div>

      <!--    
         <router-link to="/inside/note-legali" class="first _page-contatti">note legali</router-link>
         <br /><br />
         
         via g. brocchi 9/a
         <br/>
         20131 milano
         <br/>
         <a href="mailto:info@dapstudio.com">info@dapstudio.com</a>
         <br />
         P.IVA 03793790969
      -->
      </div>
    </div>
</template>

<script>

export default {
  name: 'site-side',
  data() {
      return {
        tipologiePopV: false,
        temiPopV: false
      }
    }
}
</script>


<style>
#side-title h1{
    text-align:center;
    font-size: 5.2rem;
    letter-spacing: 10px;
    margin:0 0 20px 0;
    line-height: initial;
}#side-title h1 div{
    font-size:2.2rem
}.site-side .vmenu div{
    text-align:center;
}.site-side .vmenu a, .el-popover a, .vmenupop{
    display:block;
    text-align:center;
    color:#666666;
    cursor: pointer;
    font-size: 1.3rem;
}.site-side .vmenu .top{
    font-weight: 700;
    color: #222222;
}.site-side .vmenu .first{
    margin:30px 0 4px 0;
}.site-side .vmenu a.current{
    color:#E77814;
}.site-side .vmenu a.current::before{
    content: "« "
}.site-side .vmenu a.current::after{
    content: " »"
}.site-side .nav-lang{
    text-align:center;
    
}.site-side .nav-lang a {
    color:#353535;
    padding:0 5px;
}.site-side .nav-social{
    text-align:center;
    
}.site-side .nav-social a img{
    height: 15px;
    padding:0 5px;
}.site-side .nav-bottom{
    position:fixed;
    padding: 0 0 40px 0;
    bottom:0;
    width: 160px;
    color: #222222;
}
</style>



// WEBPACK FOOTER //
// Site-side.vue?5ea093be